import { SelectDynamic } from '../models/agents/dynamic-select-list';

export class ObjectHelper {
    public EnumToList (object: any): SelectDynamic[] {
        const stringIsNumber = (value) => isNaN(Number(value)) === false;

        return Object
          .keys(object)
          .filter(stringIsNumber)
          .map(key => {
            return new SelectDynamic({id: key, value: object[key]});
          });
    }

    public EnumToListWithoutFilter (object: any): SelectDynamic[] {
      return Object
        .keys(object)
        .map(key => {
          return new SelectDynamic({id: key, value: object[key]});
        });
    }

    public SelectDynamicToAlphabeticOrder(list: SelectDynamic[]) {
      const othersOption = {id: 'Others', value: 'Outros'};
      const otherIndex = list.findIndex((element) => {
        return element.value === 'Outros';
      });
      list.splice(otherIndex, 1);
      list.push(othersOption);
      return list;
    }
}
